import { FC, ReactNode } from "react";

import { AsyncGate } from "@tsmono/react/components";

import { useAppConfigAsync } from "./hooks";

export const AppConfigGate: FC<{ children: ReactNode }> = ({ children }) => (
  <AsyncGate
    async={useAppConfigAsync()}
    errorLabel="Failed to load application configuration"
    loadingText="Loading application…"
  >
    {children}
  </AsyncGate>
);
